import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader, ModalBody, ModalFooter, Button, Grid } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import moment from 'moment';

import Input from '../../../components/Input';
import DatePicker from '../../../components/DatePicker/DatePicker';

const SearchModal = ({ isOpen, onClose, refetch, dispatch, state }) => {
  const findValue = (key) => {
    if (!state.searchValues) return '';

    // Handle nested keys like 'address.street_contains'
    const keys = key.split('.');
    let value = state.searchValues;

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return '';
    }

    // Convert ISO string dates back to moment objects for DatePicker
    if ((key === 'createdAt_gte' || key === 'createdAt_lte') && value) {
      return moment(value);
    }

    return value || '';
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>User suchen</ModalHeader>

        <Formik
          initialValues={{
            email: findValue('email_contains'),
            firstName: findValue('firstName_contains'),
            lastName: findValue('lastName_contains'),
            street: findValue('address.street_contains'),
            houseNumber: findValue('address.houseNumber_contains'),
            postalCode: findValue('address.postalCode_contains'),
            city: findValue('address.city_contains'),
            createdAt_gte: findValue('createdAt_gte'),
            createdAt_lte: findValue('createdAt_lte'),
          }}
          onSubmit={async (values) => {
            const { email, firstName, lastName, street, houseNumber, postalCode, city, createdAt_gte, createdAt_lte } = values;

            let where = {} as any;
            if (email) {
              where = {
                ...where,
                email_contains: email,
              };
            }
            if (firstName) {
              where = {
                ...where,
                firstName_contains: firstName,
              };
            }
            if (lastName) {
              where = {
                ...where,
                lastName_contains: lastName,
              };
            }
            if (street) {
              where = {
                ...where,
                address: {
                  ...where.address,
                  street_contains: street,
                },
              };
            }
            if (houseNumber) {
              where = {
                ...where,
                address: {
                  ...where.address,
                  houseNumber_contains: houseNumber,
                },
              };
            }
            if (postalCode) {
              where = {
                ...where,
                address: {
                  ...where.address,
                  postalCode_contains: postalCode,
                },
              };
            }
            if (city) {
              where = {
                ...where,
                address: {
                  ...where.address,
                  city_contains: city,
                },
              };
            }
            if (createdAt_gte) {
              where = {
                ...where,
                createdAt_gte: moment(createdAt_gte).toISOString(),
              };
            }
            if (createdAt_lte) {
              where = {
                ...where,
                createdAt_lte: moment(createdAt_lte).endOf('day').toISOString(),
              };
            }

            dispatch({ type: 'SET_SEARCH_VALUES', value: where });
            onClose();
          }}>
          {({ values, handleChange }) => (
            <Form>
              <ModalBody>
                <Input name="email" label="Email-Adresse" />
                <Grid gridTemplateColumns="1fr 1fr" gridGap="24px">
                  <Input name="firstName" label="Vorname" />
                  <Input name="lastName" label="Nachname" />
                </Grid>
                <Grid gridTemplateColumns="2fr 1fr" gridGap="24px">
                  <Input name="street" label="Straße" />
                  <Input name="houseNumber" label="Hausnummer" />
                </Grid>
                <Grid gridTemplateColumns="1fr 1fr" gridGap="24px">
                  <Input name="postalCode" label="PLZ" />
                  <Input name="city" label="Stadt" />
                </Grid>
                <Grid gridTemplateColumns="1fr 1fr" gridGap="24px">
                  <DatePicker name="createdAt_gte" label="Registriert nach" />
                  <DatePicker name="createdAt_lte" label="Registriert vor" />
                </Grid>
              </ModalBody>

              <ModalFooter>
                <Button variant="ghost" size="sm" colorScheme="red" type="button" onClick={onClose}>
                  Schließen
                </Button>
                <Button ml="4" size="sm" colorScheme="brand" type="submit">
                  Speichern
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

export default SearchModal;
